const OPAQUE_SCRIPT_ERROR_MESSAGE = 'Script error.';

type ExceptionTelemetry = {
  message?: string;
};

type ExceptionData = {
  exceptions?: ExceptionTelemetry[];
  severityLevel?: number;
  properties?: Record<string, unknown>;
};

export const isOpaqueCrossOriginScriptError = (baseData: unknown): boolean => {
  if (!baseData || typeof baseData !== 'object') {
    return false;
  }

  const { exceptions } = baseData as ExceptionData;

  return (
    exceptions?.some(
      (exception) =>
        exception.message === OPAQUE_SCRIPT_ERROR_MESSAGE
        || exception.message?.includes('Script error'),
    ) ?? false
  );
};

export const enrichOpaqueScriptErrorTelemetry = (
  baseData: ExceptionData,
  scriptSrc?: string,
): void => {
  baseData.properties = {
    ...baseData.properties,
    opaqueCrossOriginScript: true,
    ...(scriptSrc ? { scriptSrc } : {}),
  };
  baseData.severityLevel = 2; // Warning — not actionable without CORS/source details
};
